export class CashRegisterPaymentAddVendorRequest {
    vendorType?: string;
    uniqCode?: string;
    requestData?: string;
    responseData?: string;
}